/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/codes/export
 */
export interface ExportRequestBuilder extends BaseRequestBuilder<ExportRequestBuilder> {
    /**
     * One row per code, ordered by code: code, active, maxUses, usedCount, maxUsesPerCustomer, customerNumbers (semicolon-separated), validFrom, validTo, createdAt. Dates are ISO-8601 UTC.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * One row per code, ordered by code: code, active, maxUses, usedCount, maxUsesPerCustomer, customerNumbers (semicolon-separated), validFrom, validTo, createdAt. Dates are ISO-8601 UTC.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ExportRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/codes/export";
/**
 * Metadata for all the requests in the request builder.
 */
export const ExportRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExportRequestBuilderUriTemplate,
        responseBodyContentType: "text/csv, application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
